import api from "../api";
import ApiConstant from "../../constants/api.constants";

interface PosSummaryDTO{
  posID: number;
  posCode: string;
  address1: string;
  address2?: string;
  landmark?: string;
  countryName: string;
  stateName: string;
  cityName: string;
  zipcode: string;
}

const getAllPOS = async (): Promise<PosSummaryDTO[]> => {
  try {
    const response = await api.get(ApiConstant.getAllPOS);
    return response.data ?? [];
  } catch (error) {
    console.error("Error fetching POS data:", error);
    return [];
  }
};

export const posproducts = async (PosID: number[]) => {
    try {
        const Invoice = await api.post(ApiConstant.getposproducts , PosID)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading POS products list data.', error);
         });
         const response = Invoice != null ? Invoice : null;        
         return response;
    } catch (e) {
        console.log('error in POS products');
        return [];
    } 
};

const UpdatePosProducts = async (data: any) => {
    try {
        const updateproducts: any = await api
        .put(ApiConstant.updateposproducts, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating pos products', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error updating pos products');
        return false;
    }
}


export const remaingposproducts = async (PosID: number[]) => {
    try {
        const Invoice = await api.post(ApiConstant.remainingposproducts , PosID)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating pos product.', error);
         });
         const response = Invoice != null ? Invoice : null;        
         return response;
    } catch (e) {
        console.log('error in POS products');
        return [];
    } 
};

const AddPosProducts = async (data: any) => {
    try {
        const updateproducts: any = await api
        .post(ApiConstant.addposproducts, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error adding pos product', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error adding pos product');
        return false;
    }
}

export const GetOtherPosProducts = async (posId: number, productId: number) => {
  try {
    const response = await api.get(`api/POS/GetOtherPOSStock?posId=${posId}&productId=${productId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching other POS stock", error);
    return [];
  }
};

const GetinwardType = async () => {  
    try {
        const inward: any = await api
        .get(ApiConstant.getinwardtypes)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get inward Type data.', error);
         });
        const response = inward != null ? inward : null;        
        return response;
    }
    catch (e) {
        console.log('error in inward Type');
        return [];
    } 
};


const GetAllVendors = async () => {  
    try {
        const vendor: any = await api
        .get(ApiConstant.getallvendors)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get vendor details', error);
         });
        const response = vendor != null ? vendor : null;        
        return response;
    }
    catch (e) {
        console.log('error in vendor details');
        return [];
    } 
};

const AddPosInwardproducts = async (data: any) => {
    try {
        const updateproducts: any = await api
        .post(ApiConstant.addinwardproduct, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error adding inwarding product', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error adding inwarding product');
        return false;
    }
}

const GetAdjustSourceType = async () => {  
    try {
        const inward: any = await api
        .get(ApiConstant.getadjusttypes)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get Adjust Type data.', error);
         });
        const response = inward != null ? inward : null;        
        return response;
    }
    catch (e) {
        console.log('error in Adjust Type data');
        return [];
    } 
};

const AddPosAdjustproducts = async (data: any) => {
    try {
        const updateproducts: any = await api
        .post(ApiConstant.Addadjustproduct, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error adding adjust product', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error adding adjust product');
        return false;
    }
}


const GetOutwardSourceType = async () => {  
    try {
        const inward: any = await api
        .get(ApiConstant.getoutwardtypes)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get outward Type data.', error);
         });
        const response = inward != null ? inward : null;        
        return response;
    }
    catch (e) {
        console.log('error in outward Type data');
        return [];
    } 
};


export const GetRemainingPOS = async (PosID: number) => {
    try {
        const Invoice = await api.get(ApiConstant.getremainingpos + PosID)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating pos product.', error);
         });
         const response = Invoice != null ? Invoice : null;        
         return response;
    } catch (e) {
        console.log('error in POS products');
        return [];
    } 
};


const AddPosOutwardproducts = async (data: any) => {
    try {
        const updateproducts: any = await api
        .post(ApiConstant.addoutwardproduct, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error adding outward product', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error adding outward product');
        return false;
    }
}


const GetPOSMovements = async (data: any) => {
    try {
        const updateproducts: any = await api
        .post(ApiConstant.getmovementlog, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error Getting movements record', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error Getting movements record');
        return false;
    }
}

const AddPosrequest = async (data: any) => {
    try {
        const updateproducts: any = await api
        .post(ApiConstant.addrequest, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error requesting product quatitiy', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error requesting product quatitiy');
        return false;
    }
}

const Getposrequest = async (PosID: number[]) => {
    try {
        const Invoice = await api.post(ApiConstant.getposrequest , PosID)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting pos request.', error);
         });
         const response = Invoice != null ? Invoice : null;        
         return response;
    } catch (e) {
        console.log('error getting pos request');
        return [];
    } 
};


const UpdatePossend = async (data: any) => {
    try {
        const updateproducts: any = await api
        .put(ApiConstant.updatepossend, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating products status ', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error updating products status');
        return false;
    }
}

const UpdatePosReject = async (data: any) => {
    try {
        const updateproducts: any = await api
        .put(ApiConstant.updateposreject, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating products status', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error updating products status');
        return false;
    }
}

    const GetPOSSummary = async (data: any) => {
        try {
            const updateproducts: any = await api
            .post(ApiConstant.getpossummary, data)
            .then((result: any)=> {
                if(result)            
                    return result.data;
                else
                    return null;         
            })
            .catch(function (error: any) {
                console.error('error Getting summary record', error);
            });
            const response = updateproducts != null ? updateproducts : null;        
            return response;
        }
        catch
        {
            console.log('error Getting summary record');
            return false;
        }
    }

    const GetposInwardrequest = async (PosID: number[]) => {
    try {
        const Invoice = await api.post(ApiConstant.getposinwardrequest , PosID)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting pos request.', error);
         });
         const response = Invoice != null ? Invoice : null;        
         return response;
    } catch (e) {
        console.log('error getting pos request');
        return [];
    } 
};

const UpdatePosinwardAccept = async (data: any) => {
    try {
        const updateproducts: any = await api
        .put(ApiConstant.updateposinwardaccept, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating products status ', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error updating products status');
        return false;
    }
}

const UpdatePosinwardReject = async (data: any) => {
    try {
        const updateproducts: any = await api
        .put(ApiConstant.updateposinwardreject, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating products status', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error updating products status');
        return false;
    }
}

export const GetposporductDetails = async (posId: number, productId: number) => {
  try {
    const response = await api.get(`api/POS/GetPOSproductdetails?posId=${posId}&productId=${productId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching other POS stock", error);
    return [];
  }
};

const getAllPOSBatch = async (): Promise<PosSummaryDTO[]> => {
  try {
    const response = await api.get(ApiConstant.getAllPOSBatch);
    return response.data ?? [];
  } catch (error) {
    console.error("Error fetching POS data:", error);
    return [];
  }
};

const getPOSInventoryReport = async (request: {
  PosIds: number[];
  Page: number;
  PageSize: number;
  ProductIds: number[];
  SortBy: string;
  SortDescending: boolean;
}) => {
  try {
    const response = await api.post(ApiConstant.getPOSInventoryReport, request);
    return response.data ?? { Data: [], TotalRecords: 0 };
  } catch (error) {
    console.error("Error fetching POS inventory:", error);
    return { Data: [], TotalRecords: 0 };
  }
};

const getPOSInventoryExcel = async (params: { posIds: number[], productIds: number[] }) => {
  try {
    const response = await api.post(ApiConstant.getPOSInventoryExcel, params);
    return response.data ?? [];
  } catch (error) {
    console.error("Error fetching POS data:", error);
    return [];
  }
};


const getAllPosProducts = async () => {
  try {
    const response = await api.get(ApiConstant.getAllPosProducts);
    return response.data ?? [];
  } catch (error) {
    console.error("Error fetching Products data:", error);
    return [];
  }
};

const GetPOSOutwardChallan = async (data: any) => {
    try {
        const updateproducts: any = await api
        .post(ApiConstant.getPOSOutwardChallan, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error Getting movements record', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error Getting movements record');
        return false;
    }
}

const generateOutwardChallan = async (data: any) => {
    try {

        const createdChallan: any = await api
            .post(ApiConstant.generateOutwardChallan, data)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error(" Error creating challan", error);
            });

        const response = createdChallan != null ? createdChallan : null;
        return response;
    } catch {
        console.log("Unexpected error while creating challan");
        return false;
    }
};

 const formatDate = (date: Date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0"); 
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const viewOutwardChallan = async (startDate: Date, endDate: Date) => {
  try {
    const start = formatDate(startDate);
    const end = formatDate(endDate);

    debugger;
    const response = await api.get(
      `${ApiConstant.viewOutwardChallan}?startDate=${start}&endDate=${end}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching outward challan products", error);
    return [];
  }
};

const GetPOSMovementsInwardDetails = async (data: any) => {
    try {

        const POSMovementsInwardDetailsList: any = await api
            .post(ApiConstant.GetPOSMovementsInwardDetailsList, data)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error(" Error creating challan", error);
            });

        const response = POSMovementsInwardDetailsList != null ? POSMovementsInwardDetailsList : null;
        return response;
    } catch {
        console.log("Unexpected error while creating challan");
        return false;
    }
};

const GetPOSMovementsSalesInwardDetails = async (data: any) => {
    try {

        const POSMovementsInwardDetailsList: any = await api
            .post(ApiConstant.GetPOSMovementsSalesDetailsList, data)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error(" Error creating challan", error);
            });

        const response = POSMovementsInwardDetailsList != null ? POSMovementsInwardDetailsList : null;
        return response;
    } catch {
        console.log("Unexpected error while creating challan");
        return false;
    }
};


const posService = {
  getAllPOS,
  posproducts,
   UpdatePosProducts,
   remaingposproducts,
   AddPosProducts,
   GetOtherPosProducts,
   GetinwardType,
   GetAllVendors,
   AddPosInwardproducts,
   GetAdjustSourceType,
   AddPosAdjustproducts,
   GetOutwardSourceType,
   GetRemainingPOS,
   AddPosOutwardproducts,
   GetPOSMovements,
   AddPosrequest,
   Getposrequest,
   UpdatePossend,
   UpdatePosReject,
   GetPOSSummary,
   GetposInwardrequest,
   UpdatePosinwardAccept,
   UpdatePosinwardReject,
   GetposporductDetails,
   getAllPOSBatch,
   getPOSInventoryReport,
   getPOSInventoryExcel,
   getAllPosProducts,
   GetPOSOutwardChallan,
   generateOutwardChallan,
   viewOutwardChallan,
   GetPOSMovementsInwardDetails,
   GetPOSMovementsSalesInwardDetails
};

export default posService;
